import React from 'react';
import { useContent } from '@/providers/ContentProvider';
import { Language } from '@/types/types';
import { Flex, NativeSelect, Select, SelectProps, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import IconChevronDown from '@/assets/icons/outline/chevron-down.svg?react';
import APP_CONFIG from '@/configs/appConfig';
import LANGUAGES from '@/configs/languages';
import styles from '../Navbar.module.scss';

const renderSelectOption: SelectProps['renderOption'] = ({ option }) => {
	const Flag = LANGUAGES[option.value as Language].flag;

	return (
		<Flex gap="sm">
			<Flag w={25} h={18.75} />
			{option.label}
		</Flex>
	);
};

export const LanguageSelect: React.FC = () => {
	const { getContent, language, setLanguage } = useContent();

	const data = Object.entries(LANGUAGES).map(([lang, { name }]) => ({
		value: lang,
		label: getContent(name),
	}));
	const mobileBreakpoint = useMediaQuery(
		`(max-width: ${rem(APP_CONFIG.BREAKPOINTS.MD)} )`
	);

	const SelectedFlag = LANGUAGES[language].flag;

	const handleChange: SelectProps['onChange'] = (lang) => {
		if (!lang) return;

		setLanguage(lang as Language);
	};

	return mobileBreakpoint ? (
		<div className={styles.langContainer}>
			<div className={styles.nativeSelectWrapper}>
				<NativeSelect
					size="md"
					data={data}
					classNames={{
						input: styles.nativeSelectInput,
						section: styles.selectSection,
					}}
					onChange={(e) => setLanguage(e.currentTarget.value as Language)}
					value={language}
				/>
			</div>
		</div>
	) : (
		<Flex gap="sm">
			<SelectedFlag w={25} h={18.75} />
			<Select
				w={85}
				value={language}
				data={data}
				onChange={handleChange}
				renderOption={renderSelectOption}
				rightSection={<IconChevronDown />}
				comboboxProps={{
					position: 'left-start',
				}}
				rightSectionWidth={20}
				classNames={{
					input: styles.selectInput,
					dropdown: styles.selectDropdown,
				}}
			/>
		</Flex>
	);
};
